import React from "react";
import { Container } from "../../globalStyles";
import {
  ImgWrapper,
  InfoSec,
  Img,
  InfoRow,
  InfoColumn,
  Contact,
  ContactContainer,
} from "./InfoSection.elements";
import ContactForm from "../Contactform/Contactform";

const Infocontact = ({ lightBg, start, img, alt, imgStart }) => {
  return (
    <>
      <InfoSec lightBg={lightBg}>
        <Container>
          <InfoRow imgStart={imgStart}>
            <InfoColumn>
              <ImgWrapper>
                <Contact>
                  <ContactContainer>
                    <ContactForm />
                  </ContactContainer>
                </Contact>
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <ImgWrapper start={start}>
                <Img src={img} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
          </InfoRow>
        </Container>
      </InfoSec>
    </>
  );
};

export default Infocontact;
